var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGr = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0d5eaf",
  fillRule: "evenodd",
  d: "M0 0h640v53.3H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M0 53.3h640v53.4H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0d5eaf",
  fillRule: "evenodd",
  d: "M0 106.7h640V160H0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M0 160h640v53.3H0z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#0d5eaf",
  d: "M0 0h266.7v266.7H0z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#0d5eaf",
  fillRule: "evenodd",
  d: "M0 213.3h640v53.4H0z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M0 266.7h640V320H0z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#0d5eaf",
  fillRule: "evenodd",
  d: "M0 320h640v53.3H0z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M0 373.3h640v53.4H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  fillRule: "evenodd",
  strokeWidth: 1.3
}, /*#__PURE__*/React.createElement("path", {
  d: "M106.7 0H160v266.7h-53.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 106.7h266.7V160H0z"
}))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#0d5eaf",
  d: "M0 426.7h640V480H0z"
})));
export { SvgGr as ReactComponent };
export default __webpack_public_path__ + "assets/images/gr.969458b727378ff7b215343cfc6c9165.svg";